import { FC } from "react";

import { FormType } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { FORM_ELEMENT_IDS } from "@/features/LiveFormEditor/Steps/helpers/formStepToElementIdMap";
import { FormLocation, FormLocationProps } from "@/forms-design-system/FormLocation";

type AuctionLocationProps = Omit<FormLocationProps, "title" | "subtitle"> & {
  address?: string;
  latitude?: number;
  longitude?: number;
};

export const AuctionLocation: FC<AuctionLocationProps> = ({ address: addressProp, latitude, longitude, ...rest }) => {
  const { t } = useTranslate();
  const { formObject, hasLocation } = useFormV2Context(FormType.Ticketing);
  const isLocationGhostPreview = useIsGhostPreview("TicketingV2AddressSummary");

  const address = addressProp ?? formObject.address ?? undefined;
  const resolvedLatitude = latitude ?? formObject.coordinates?.latitude ?? undefined;
  const resolvedLongitude = longitude ?? formObject.coordinates?.longitude ?? undefined;

  if (!addressProp && !hasLocation) {
    return null;
  }

  const googleMapsLink =
    resolvedLatitude && resolvedLongitude
      ? `https://www.google.com/maps?q=${resolvedLatitude},${resolvedLongitude}`
      : undefined;

  return (
    <FormLocation
      id={FORM_ELEMENT_IDS["location"]}
      data-test="ticketing-address-summary"
      title={t("ticketing", "auction.pickupLocation")}
      href={googleMapsLink}
      target="_blank"
      rel="noopener noreferrer"
      subtitle={address}
      components={{
        title: {
          sx: {
            textDecoration: "none !important",
          },
        },
        ...rest.components,
      }}
      sx={{ opacity: isLocationGhostPreview ? GHOST_PREVIEW_OPACITY : 1, ...rest.sx }}
      {...rest}
    />
  );
};
